<div class="content " role="main">




    <p>Not Authenticated</p>
    <!-- <br> -->
    <p>{{!auth.isAuthenticated$}}</p>
    <!-- Prevent the Not Logged in template flashing on load -->

    <!-- User Not Logged in -->
    <br>
    <p>Welcome to the Asset Management App Design phase</p>

    <div class="mat-elevation-z4 content-center"
        style="padding: 5px;border-radius: 10px;margin-bottom: 1em; width: 500px;" *ngIf="!env.production">
        <p>Security</p>
        <div class="option-select">
            <ng-container *ngIf="auth.isAuthenticated$ | async; else loggedOut">
                <span *ngIf="auth.user$ | async as user">Hello <b>{{user.name}}</b> You are Logged in</span>
                <button (click)="logout()">Log out</button>
            </ng-container>

            <ng-template #loggedOut>
                <button (click)="logIn()">Log in</button>
            </ng-template>
        </div>

    </div>
    <div class="mat-elevation-z4 content-center"
        style="padding: 5px;border-radius: 10px; width: 500px;background-color: var(--color-red);" *ngIf="!env.production">
        <h3>Security Debugging</h3>
        <p>Domain:{{env.auth.domain}}</p>
        <p>clientId:{{env.auth.clientId}}</p>
        <p>audience:{{env.auth.audience}}</p>
        <p>apiUrl:{{env.apiUrl}}</p>
        <p>errorPath:{{env.auth.errorPath}}</p>
    </div>

</div>
